





























import { Component, Vue } from 'vue-property-decorator';
import SignOffField from '@/components/jobServiceForm/SignOffField.vue';

@Component({
  components: {
    SignOffField
  }
})
export default class ServiceFormApprovalStatement extends Vue {

}

